import $ from "jquery";

/**
 * Load the ajax search
 *
 * Dom element with the class ajax-search-hide will be hidden
 * Dom element with the class ajax-search-remove will be deleted
 * Dom element with the class ajax-search-empty will be cleaned
 * Dom element with an data-ajax-search-replace attribute will see its content replace by the value of this attribute
 * Dom element with an data-ajax-search-load-more-url attribute will do an ajax query with the url defined in this attribute
 * Dom form.data-ajax-search-form on change
 *
 * Dom element with aria-live will be updated by the result of ajax query (loop on all json attributes starting by the string 'html_'
 *      the content is replaced if the role="status" or if it's change event on the search form
 *      the content is appended if it's a "load more" event (and the role != "status")
 *
 * Dom element with data-ajax-search-loading-hide class are hidden during ajax calls and displayed after
 * Dom element with data-ajax-search-loading-show class are show during ajax call and hide after (i.e. loaders)
 *
 */
export default function ajaxSearch(submitOnKeyStroke = false) {
    const $ = require('jquery');
    let requestInProgress = false;
    let nextRequest;

    $('.ajax-search-hide').hide();
    $('.ajax-search-empty').empty();
    $('.ajax-search-remove').remove();

    const updateDom = function(msg) {
        for (const key of Object.keys(msg)) {
            if (key.startsWith("html_")) {
                const html = $('<div/>').html(msg[key]);
                html.find('[aria-live]').each(function() {
                    const item = $(this);
                    const id = item.attr('id');
                    if (!id) {
                        console.log('aria-live without id!');
                        return;
                    }
                    const target = $('#'+id);
                    if (msg.page == 0 || target.attr('role') === 'status') {
                        addClickListener(target.html(item.contents()).get(0));
                    }
                    else {
                        addClickListener(target.append(item.contents()).get(0));
                    }

                    $('.selectpicker').selectpicker('refresh');
                });

                if (msg.title) {
                    $('h1').html(msg.title);
                }

                if (msg.title_header) {
                    document.title = $('<textarea />').html(msg.title_header).text();
                }

                if (msg.load_more_path && msg.load_more_path !== '') {
                    $('[data-ajax-search-load-more-url]').show().attr('data-ajax-search-load-more-url', msg.load_more_path);
                }
                else {
                    $('[data-ajax-search-load-more-url]').hide().attr('data-ajax-search-load-more-url', '');
                }

            }
        }
    };


    const doAjaxRequest = function(url) {

        if (requestInProgress) {
            nextRequest = url;
            return;
        }
        requestInProgress = true;

        $('.data-ajax-search-loading-hide').hide();
        $('.data-ajax-search-loading-show').show();

        $.ajax(url)
            .done(function(msg) {
                updateDom(msg);
                history.pushState(msg, '', forms.attr('action') + '?' + forms.serialize())
            })
            .fail(function() {
                alert( "error with this page" );
            })
            .always(function(){
                requestInProgress = false;
                if (nextRequest && nextRequest !== url) {
                    const newUrl = nextRequest;
                    nextRequest = false;
                    doAjaxRequest(newUrl);
                    return;
                }
                nextRequest = false;
                $('.data-ajax-search-loading-hide').show();
                $('.data-ajax-search-loading-show').hide();
            });
    };

    const loadMore = function(){
        const loadMoreButton = $(this);
        const url = loadMoreButton.attr('data-ajax-search-load-more-url');
        doAjaxRequest(url);
    };

    $('[data-ajax-search-replace]').each(function(){
        const item = $(this);
        const replacement = $(item.data('ajax-search-replace'));
        replacement.find('[data-ajax-search-load-more-url]').on('click', loadMore);

        item.empty().append(replacement);
    });


    const forms = $('[data-ajax-search-form]');

    const formChangeFunction = function (event) {
        formSubmitFunction(event, false);
    };

    const formSubmitFunction = function (event, clearAriaLive = true) {
        event.preventDefault();

        const arias = [];
        $('[aria-live]').each(function() {
            const id = $(this).attr('id');
            if (id) {
                arias[id] = ($(this).html());
            }
        });

        if (clearAriaLive) {
            $('[aria-live]').empty();
        }
        else {
            $('[aria-live]').not('[role=status]').empty();
        }
        doAjaxRequest(forms.attr('data-ajax-search-form') + '?' + forms.serialize());
    };

    window.onpopstate = function(event) {
        if (event.state) {
            updateDom(event.state)
        }
    }

    function addClickListener(target) {
        let links = target.querySelectorAll('.ajax-search-link');
        links.forEach((link) => {
            link.addEventListener('click', (event) => {
                event.preventDefault();
                let facetId = link.dataset.facet;
                let serviceId = link.dataset.service;

                if (facetId) $('select#filter-search_facet').selectpicker('val', facetId);
                if (serviceId) $('select#filter-search_service').selectpicker('val', serviceId);

                formChangeFunction(event);
            })
        });

        let activeLink = document.querySelector('#search-sidebar .active a');
        if (activeLink) activeLink.focus();
    }
    addClickListener(document);

    forms.change(formChangeFunction);
    forms.submit(function(event) {
        event.preventDefault();
    });
    if (submitOnKeyStroke) {
        //The following lines allow submit on key stroke
        forms.find("input[type=text]").on('input', formSubmitFunction);
        forms.find("textarea").on('input', formSubmitFunction);
    }

    const initialState = forms.data('initialState')
    if (initialState) {
        history.replaceState(initialState, "", document.location.href)
    }


}
